/**
 * This returns a boolean, indicating if the received id as param is local(created by client)
 * @param id
 * @returns {*}
 */
export default id => id?.toString().startsWith('local-')
